module.exports = __webpack_public_path__ + "img/church paint cut.7814feb5.jpg";